export const STATUSES = {
  0: 'gray',
  1: 'green',
  2: 'red',
  3: 'black'
};
